import script from "./CarouselCards.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselCards.vue?vue&type=script&setup=true&lang=js"

import "./CarouselCards.vue?vue&type=style&index=0&id=6c6c5392&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c6c5392"]])

export default __exports__